<template>
  <div  id="Filter" class="container p-4 " >
    <K2Row align="center" class="me-2 search-wrap" >
      <span class="label-control me-2 ">Date</span>
      <el-date-picker
        size="small"
        v-model="date"
        placeholder="Select"
        v-bind:type=dateType
      >
      </el-date-picker>
    </K2Row>

    <K2Filter :filter-list="filterList" :dateType="dateType" @onFilter="handleFilter" @onFilterChange="onFilterChange" />
    <div  id="ReportHtml" class="container" v-if="Data.length!=0">
      <div class="row header mb-5">
        <div>The report would be sent to your email. Please check your email in 15 mins </div>
      </div>
    </div>

  </div>

</template>

<script>
import K2Button from "@/uiComponents/k2Button/k2Button";
import K2Heading from "@/uiComponents/k2Heading/k2Heading";
import K2Row from "@/uiComponents/k2Row/k2Row";
import K2Filter from "@/uiComponents/k2Filter/k2Filter";
import VueHtml2pdf from "vue-html2pdf";
import ReportContent from "@/pages/AttendanceReports/ReportContent";
import uiVariable from "@/config/uiVariable";
import Cookies from "js-cookie";
import { lang } from "@/locale";
import DataSource from "@/data/datasource";

export default {
  name: "DailyAttendanceReport",
  components: { K2Row, K2Filter,VueHtml2pdf,ReportContent},
  async created() {
    this.schID = Cookies.get('schoolSession');
    await this.getSchools();
    await this.getStudentTypes();
  },
  data() {
    return {
      uiVariable: uiVariable,
      dateType: 'date',
      date : '',
      selectedSchool: '',
      studentType: '',

      studentTypes: [],
      filterList: [{
        label: "Schools",
        placeholder: "Filter by Schools",
        optionList: []

      }, {

        label: "StudentType",
        placeholder: "All Students",
        optionList: []

      },],
      Data : []
    }
  },
  methods: {
    lang,
    async loadReport (){
      this.$vs.loading();
      try {
        const d = new Date( this.date);
        const d2= new Date( this.date);
        d2.setDate(d2.getDate() + 1);

        const response = await DataSource.shared.GetDailyAttendanceReportData(d.toLocaleDateString('en-GB'), d2.toLocaleDateString('en-GB'), this.selectedSchool,this.studentType);
        if (response) {

          this.Data = response.Table;
          console.log(response);
        }
      }
      catch (e) {
        this.results = e;
        console.log(e);
      }
      this.$vs.loading.close();

    },
    async getSchools() {
      const response = await DataSource.shared.getSchoolDropdownList("UTY201300000061");
      if (response){
        response.Table.forEach(d => {
          d.id = d.SchoolID;
          d.label = d.SchoolName;
          d.type = "school";
        });
      }
      this.filterList[0].optionList = response.Table;

    },
    async getStudentTypes() {
      try {
        let jsonString = '"Residency Status":"Residency Status"';
        jsonString = "{" + jsonString + "}";
        const response = await DataSource.shared.getStudentDropDownList(jsonString);

        if (response) {
          response.Table.forEach(d => {
            d.id = d.OPTvalue;
            d.label = d.OPTvalue;
            d.type = "student type";
          });
          this.filterList[2].optionList = response.Table;
        }
      } catch (e) {
        this.results = e;
      }
    },
    handleFilter(type) {

      if (this.filterList[0].selected !== undefined){
        this.selectedSchool = (this.filterList[0].selected).toString();
      }
      if (this.filterList[1].selected !== undefined){
        this.studentType = (this.filterList[2].selected).toString();
      }

      this.loadReport();

    },
    onFilterChange(value) {
      console.log(type);
      this.getClass(value);

    },
  }

};
</script>

<style scoped>

</style>